export const LOGGER_LINE_NUMBER_INDEX_DELTA = 1;
export const NUMBER_INDEX_DELTA = 1;
export const DEFAULT_AMOUNT = 0;
export const DEFAULT_INDEX = 0;
export const DEFAULT_MATCH = 0;
export const DEFAULT_FOCUS = -1;
export const MIN_SEARCH_INPUT_LENGTH = 3;
export const DEFAULT_SEARCH_INDEX = 0;
//# sourceMappingURL=constants.js.map